export default __webpack_public_path__ + "static/media/Ideas.66bed0a0.jpg";